import type { TopicName } from 'magpie-types';
import { createError } from './create-error';

export const TopicUnsubscribeError = createError(
  'TopicUnsubscribeError',
  (topic: TopicName) => `Failed to unsubscribe from topic '${topic}'.`,
  {
    CONNECTION_UNAVAILABLE: "Connection wasn't opened",
    HANDSHAKE_FAILED: 'Connection unavailable. Handshake not finalized.',
    BROKER_UNAVAILABLE: 'Connection to broker has failed',
    STORAGE_UNAVAILABLE: 'Topic subscription storage is unavailable',
    FAILED_TO_UPDATE_STORAGE: 'Failed to update storage',
  } as const
);
